import React from 'react';
import classNames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import s from './index.module.scss';

function MenuButton ({ disableFromFocus, planMan }) {
	const dispatch = useDispatch();
	const menuOpened = useSelector((state) => state.global.menuOpened);
	const stateClass = menuOpened ? s.opened : '';
	const lineWidth = planMan ? s.lineThin : '';

	function toggle () {
		dispatch({
			type: 'TOGGLE_MENU',
			payload: !menuOpened
		});
	}

	return (
		<button className={classNames(s.menuButton, stateClass)} type="button" onClick={toggle} tabIndex={disableFromFocus}>
			<span className={classNames(s.line1, lineWidth)} />
			<span className={classNames(s.line2, lineWidth)} />
			<span className={classNames(s.line3, lineWidth)} />
		</button>
	);
}

export default MenuButton;
